import styled from 'styled-components'
import variablesApplicationConfig from '../../../../variables'

const ContainerSectionSpecialtiesCircular = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;

  .middle-section {
    width: 100%;
    max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px;

    margin-top: 40px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;

    margin-bottom: 100px;
    margin-top: 80px;

    .m-s-top {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 60px;

      .m-s-t-left {
        color: ${(props) =>
          props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};
        width: 80%;

        .m-s-t-l-label {
          font-weight: 700;
          font-size: 18px;
          font-family: var(--secondary-font-family);

          display: flex;
          align-items: center;

          svg {
            width: 50px !important;
            margin-top: 6px;
            margin-left: 10px;
          }
        }
        .m-s-t-l-title {
          font-size: 50px;
          line-height: 60px;
          font-weight: bold;
          margin-top: 10px;
          transition: all 0.6s ease-in-out;
          color: black;
        }
      }

      .m-s-t-right {
        .m-s-t-r-action {
          display: flex;
          width: min-content;
          background-color: var(--primary-color);
          color: white;
          white-space: nowrap;

          margin-top: 30px;

          padding: 16px 26px 17px;

          border-radius: 100px;

          cursor: pointer;

          svg {
            font-size: 20px;
            margin-left: 10px;
          }
        }
      }
    }
    .m-s-bottom {
      width: 100%;
      display: flex;

      .m-s-b-left {
        width: 65%;

        display: flex;
        gap: 30px;
        flex-wrap: wrap;
        margin-right: 30px;

        .specialty-list-item {
          width: calc(50% - 15px);

          padding: 40px;

          display: flex;
          flex-direction: column;

          gap: 20px;

          border: 1px solid #e3dbd8;

          transition: all 0.3s ease-in-out;

          border-radius: 20px;

          cursor: pointer;

          &:hover {
            border: 1px solid
              ${(props) =>
                props.color
                  ? 'var(--primary-color)'
                  : 'var(--secondary-color)'};
          }

          .specialty-list-item-image {
            width: 65px;
            height: 65px;

            border-radius: 10px;

            background-color: rgba(0, 0, 0, 0.1);
          }
          .specialty-list-item-title {
            font-size: 30px;
            line-height: 36px;
            font-weight: 600;
            color: ${(props) =>
              props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};
          }
          .specialty-list-item-description {
            color: #727272;
            font-size: 16px;
            line-height: 30px;
          }
        }
      }

      .m-s-b-right {
        width: calc(35% - 30px);
        height: 100% auto;
        background-color: rgba(0, 0, 0, 0.1);

        border-radius: 20px;
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px) {
    .middle-section {
      .m-s-top {
        .m-s-t-left {
          margin-left: 30px;
        }
        .m-s-t-right {
          margin-right: 30px;
        }
      }
      .m-s-bottom {
        .m-s-b-left {
          width: 100%;
          margin-left: 30px;
        }
        .m-s-b-right {
          width: 65%;
          display: none;
        }
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    .middle-section {
      .m-s-top {
        .m-s-t-left {
          width: 100% !important;
          max-width: 50% !important;
          .m-s-t-l-title {
            font-size: 30px !important;
            line-height: 40px !important;
          }
        }
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    .middle-section {
      .m-s-top {
        .m-s-t-left {
          width: 100% !important;
          max-width: 80% !important;
        }
        .m-s-t-right {
          display: none !important;
        }
      }
      .m-s-bottom {
        .m-s-b-left {
          flex-wrap: wrap !important;
        }
        .specialty-list-item {
          width: 100% !important;
          padding: 30px !important;
        }
      }
    }
  }
`

export default ContainerSectionSpecialtiesCircular
